import React from 'react';
const painPoints = ['Llegás a la clase sin saber exactamente qué ejercicio vas a dar hoy', 'Tus alumnas no progresan porque no tenés una secuencia clara de aparato en aparato', 'El 40% de tus alumnas abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos ejercicios de siempre porque no tenés más material listo', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Correcciones técnicas improvisadas en el piso, sin un método claro que te respalde', 'Alumnas de distintas edades y niveles juntas y la clase se convierte en un caos', 'Fin de mes y las alumnas se van sin avisar porque no ven progresión en sus clases'];
export function PainPoints() {
  return <section className="py-10 md:py-20 bg-secondary-dark text-white relative overflow-hidden" data-id="element-239">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: 'radial-gradient(#fff 1px, transparent 1px)',
      backgroundSize: '24px 24px'
    }} data-id="element-240"></div>

      <div className="container mx-auto px-4 relative z-10 max-w-4xl" data-id="element-241">
        <div className="text-center mb-6 md:mb-12" data-id="element-242">
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-2 md:mb-4" data-id="element-243">
            Si sos instructora de gimnasia rítmica infantil en Argentina, esto
            te va a sonar familiar:
          </h2>
        </div>

        <div className="space-y-2.5 md:space-y-4 mb-8 md:mb-16" data-id="element-244">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-3 md:gap-4 bg-white/10 p-3 md:p-5 rounded-xl border border-white/10 hover:bg-white/15 transition-colors" data-id="element-245">
              <div className="flex-shrink-0 w-8 h-8 md:w-10 md:h-10 rounded-full bg-primary flex items-center justify-center font-bold text-sm md:text-lg shadow-lg" data-id="element-246">
                {String(index + 1).padStart(2, '0')}
              </div>
              <p className="text-sm md:text-lg pt-1 md:pt-1.5 font-medium text-gray-100" data-id="element-247">
                {point}
              </p>
            </div>)}
        </div>

        <div className="text-center bg-primary p-5 md:p-8 rounded-2xl shadow-xl border border-primary-light/20" data-id="element-248">
          <h3 className="text-xl md:text-3xl font-bold font-serif" data-id="element-249">
            ¿Cuántas clases más vas a improvisar antes de tener un sistema real?
          </h3>
        </div>
      </div>
    </section>;
}